import * as React from 'react';



export default class threeLayout extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16"  className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
         <g fill="none" fillRule="evenodd">
            <g transform="translate(1 2)">
                <path stroke="#000" strokeLinecap="round" d="M.538 1.615h12.924M.538 4.77H1.77M.538 6.923H1.77M.538 9.077H1.77"/>
                <path fill="#43ADF1" d="M8 4h2v7H8z"/>
                <rect width="6" height="7.615" x="3.5" y="3.5" stroke="#000" rx="1"/>
                <rect width="1.615" height="1.923" x="11.5" y="4.5" stroke="#000" rx=".808"/>
                <rect width="1.615" height="1.923" x="11.5" y="8.5" stroke="#000" rx=".808"/>
            </g>
        </g>
      </svg>
    )
  }
}
